import React from 'react';
import Select from 'react-select';
import { t } from 'i18next';
import { MultiValue, ActionMeta } from 'react-select';

interface SelectProps {
  setSelectedTasks: (ids: number[]) => void;
  selectedOptions: any;
  users: any;
  setSelectedOptions: any;
}

interface UserOption {
  value: number;
  label: string;
}

const SelectUsersEdit: React.FC<SelectProps> = ({ setSelectedTasks, selectedOptions, users, setSelectedOptions }) => {

  const handleSelectChange = (
    selected: MultiValue<UserOption>,
    _actionMeta: ActionMeta<UserOption>
  ) => {
    const ids = selected.map(opt => opt.value);
    setSelectedTasks(ids);
    setSelectedOptions(selected);
  };

  return (
    <Select
      isMulti
      isClearable
      name="users"
      closeMenuOnSelect={false}
      placeholder={t('Choose users')}
      value={selectedOptions}
      onChange={handleSelectChange}
      options={users}
      className="basic-multi-select w-full bg-[var(--bg-input)]"
      classNamePrefix="select"
    />
  );
};

export default SelectUsersEdit;
